import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Respondent} from '../model/respondent';
import {ApplicationContext} from '../model/application-context';
import {ProjectService} from '../project/project.service';
import {ReportDefinition} from '../model/reportDefinition';
import {ReportFilterByDate} from '../model/reportFilter/reportFilterByDate';
import {ReportFilterByTerminalID} from '../model/reportFilter/reportFilterByTerminalID';
import {ReportFilterByDeviceName} from '../model/reportFilter/reportFilterByDeviceName';
import {ReportFilterByAnswer} from '../model/reportFilter/reportFilterByAnswer';
import {CreateQuestionnaireComponent} from '../project/createQuestionnaire/create-questionnaire.component';
import {LoadingCirclesComponent} from '../loading-animation-2/loading-circles.component';

@Component(
    {
        selector: 'reportFilter',
        template: `
            <div [style.display]="hide ? 'none' : 'inline'" class="modal" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <img class="explorerWindow" src="../../assets/images/SEOIcon.png">
                            <h4 class="modal-title">Excel Report Filter</h4>
                                <h4 class="closeBtnH4"><button (click)="toggleFilter();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                                    <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                                </button></h4>
                        </div>
                        <div class="modalBodyContainer">
                            <div class="modal-body col-md-12">
                                <table>
                                    <tr>
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-primary">{{this.reportSelectedDevice.deviceName}}</button>
                                            <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <span class="sr-only">Toggle Dropdown</span>
                                            </button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item"  (click)="setFilterDevice(term)" *ngFor="let term of availablePhysicalDevices">{{term}}</a>
                                            </div>
                                        </div>
                                    </tr>
                                    <tr>
                                        <div style="border: #00b0ff;border-width: medium;border-style: solid;margin-top: 10px;">
                                            <label>Date Constraints</label>
                                            <table>
                                                <tr>
                                                    <td><label>Start Date</label></td>
                                                    <td><ejs-datepicker id='datepicker' placeholder='Select a date' [value]='dateValue' [min]='minDate' [max]='maxDate' (change)="startDateChanged($event)"></ejs-datepicker></td>
                                                </tr>
                                                <tr>
                                                    <td><label>End Date</label></td>
                                                    <td><ejs-datepicker id='datepicker' placeholder='Select a date' [value]='dateValue' [min]='minDate' [max]='maxDate' (change)="endDateChanged($event)"></ejs-datepicker></td>
                                                </tr>
                                            </table>
                                            <button class="btn btn-primary" style="margin-left:5px;margin-bottom:5px;" (click)="resetDate()"> Reset Date</button>
                                        </div>
                                    </tr>
                                    <tr>
                                            <div class="btn-group" style="margin-top: 10px;margin-bottom: 10px;">
                                                <button type="button" class="btn btn-primary">{{this.reportFilterByTerminalID.terminalID==0?'Filter By Terminal ID':this.reportFilterByTerminalID.terminalID}}</button>
                                                <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span class="sr-only">Toggle Dropdown</span>
                                                </button>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item"  (click)="setFilterTerminalID(term)" *ngFor="let term of availableTerminals">{{term}}</a>
                                                </div>
                                            </div>
                                    </tr>
                                    <tr><Label class="formCheckbox">Avoid Test Respondents</Label><input type="checkbox" [checked]="avoidTestRespondent"></tr>
                                    <tr><Label class="formCheckbox">Add MetaData</Label><input type="checkbox" [checked]="this.def.addMetadata" [(ngModel)]="this.def.addMetadata"></tr>
                                    <tr><Label class="formCheckbox">Include Pictures</Label><input type="checkbox" [checked]="this.def.includeImages" [(ngModel)]="this.def.includeImages"></tr>
                                    <tr >
                                        <table style="margin-top:20px;">
                                            <tr>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="inputGroup-sizing-default">Search a specific answer</span>
                                                    </div>
                                                    <input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"  [(ngModel)]="specificAnsFilter">
                                                </div>
                                            </tr>
                                        </table>
                                    </tr>
                                </table>
                            <div *ngIf="!hideLoadingAnimation"> <loadingCircles></loadingCircles></div>
                                <div class="modal-footer ">
                                    <button class="btn btn-primary" (click)="downloadNow()">Download Report</button>
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
                    </div>`,
        styles:[`
    .menu td{padding-left: 20px;}
    .back{margin-right:10px;}
    loadingCircles{position: absolute;top: 150px;left: 500px;}

    .modal-title{margin-left:10px;}
    .explorerWindow{height:32px;}
    .window{margin-right: 10px;}
    .list{margin-right: 10px;}
    li {list-style: none;}
    table {width: 100%;}

    ul li:hover {
      background: -webkit-linear-gradient(top, #648bf5, #2866f2);
      background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
      border-top: 1px solid #5a82eb;
      border-bottom: 1px solid #1758e7;
    }

    ul li:hover::after .dropmenu{
      color: #ffffff;
    }

    .modal-header{
        background-color:dodgerblue;
        color:antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    .modal-content{
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
    }
    .closeX{color:azure;size:25px;}
    .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
    .btn-danger:hover{background-color: #FF2400;}

            /* new css*/

    .formCheckbox{margin-right: 5px;}

    .modal-title{margin-top: -5px;}
    .closeBtnH4{margin-top:-5px;margin-right: -8px;}
    .appWindow {
        height: 35px;
    }
    .clientRow{background-color: #D0DFFE;}

    .led{width:22px;}

    .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
    th{color:#ffffff;text-align: center;}

    .modal-footer{background-color:  #ECE8E5;border-top: groove;}
    .modal-body {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        overflow-y: auto;
    }
    .modal-body thead {
        position: sticky;
        top:0;
    }
    ::-webkit-scrollbar {
        width: 14px;
        height: 5px;
        background-color: #F5F3F0;
    }
    ::-webkit-scrollbar-thumb {
        height: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-border-radius: 7px;
        background-color:#BACEFF;
        -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
    ::-webkit-scrollbar-button {
        width: 14px;
        height: 14px;
        display: none;
    }
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    .modal-dialog {
        max-width: 1500px;
        margin: 50px auto auto;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }


    .modal-header {
      height:56px;
      background-image: url("../../assets/images/headerBack.jpg");
      color: antiquewhite;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
    }
    .modal-content{
      border-top-right-radius: 18px;
      border-top-left-radius: 18px;
      padding-left: 3px;
      padding-right: 3px;
      background-color: #0064FE;
      padding-bottom: 3px;
    }

    .modalBodyContainer{
      background-color:  #ECE8E5;
    }

    .closeX {
        color: white;
        size: 25px;
    }

    .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
    }

    /* .btn-outline-danger:hover {
         width: 32px;
         background-image: url("../../../assets/images/closeBtnHovered.png");
     }*/

    .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

    .closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}
  `]
    })
export class ReportFilterComponent {

    @Input() appContext:ApplicationContext;

    @Input() availableTerminals:string[];

    @Input() availablePhysicalDevices:string[];

    @ViewChild(LoadingCirclesComponent)  private loadingCircles:LoadingCirclesComponent;

    private hide  = true;

    private hideLoadingAnimation = true;

    private selectedDevice = 'Filter by Device';

    private selectedTerminalId = 0;

    private avoidTestRespondent = true;

    private specificAnsFilter:string;

    private startDate = ''; // milliseconds in string representation

    private endDate = ''; // milliseconds

    private filter = false;

    public minDate: Date = new Date ('01/01/1979');

    public maxDate: Date = new Date ('01/01/2100');

    public dateValue: Date = new Date (Date());

    private  def = new ReportDefinition();
    private  reportFilterByDate = new ReportFilterByDate();
    private  reportFilterByTerminalID = new ReportFilterByTerminalID();
    private  reportSelectedDevice = new ReportFilterByDeviceName();
    private  reportSelectSpecificAnswer = new ReportFilterByAnswer();


    constructor(private _projectService:ProjectService) {

    }

    public toggleFilter() {
        if(this.appContext.dataNavigationState.selectedView ==='quickLinkExcelReport') {
            this.appContext.dataNavigationState.selectedView = 'report';
        }
        this.hide = !this.hide;
    }

    setFilterTerminalID(terminalId: string) {
        this.reportFilterByTerminalID.terminalID = Number(terminalId);
    }

    private downloadNow() {
        this.filter = true;

        this.hideLoadingAnimation = false;

        this.def.refresh();
        this.def.filter.push(this.reportFilterByDate);
        this.def.filter.push(this.reportFilterByTerminalID);
        this.def.filter.push(this.reportSelectedDevice);
        this.reportSelectSpecificAnswer.answer = this.specificAnsFilter;
        this.def.filter.push(this.reportSelectSpecificAnswer);

        const saveAs = require('file-saver');
        this._projectService.excelReport(this.appContext.questionnaire.id, this.appContext.searchFilters,this.def)
            .subscribe((data:any) => {
                    this.hideLoadingAnimation = true;
                    // if(this.def.includeImages) {
                        saveAs.saveAs(data.body, data.headers.get('Content-Disposition').split(';')[1].split('=')[1]);
                    /*} else{
                        saveAs.saveAs(data.body, 'report.xls');

                    }*/
                },
                error => console.log('Error downloading the file.'));
    }

    startDateChanged($event:any) {
        console.log($event);
       // this.startDate = $event.value.getTime().toString();
        this.reportFilterByDate.minDate = $event.value.getTime().toString();
    }

    endDateChanged($event:any) {
        console.log($event);
        // this.endDate = $event.value.getTime().toString();
        this.reportFilterByDate.maxDate = $event.value.getTime().toString();
    }


    setFilterDevice(term: string) {
        this.reportSelectedDevice.deviceName = term;
    }

    resetDate() {
        this.startDate = '';
        this.endDate = '';
    }
}
